import { useDispatch, useSelector } from "react-redux";
import useCheckLogin from "../../hook/useCheckLogin";
import { Box, chakra, Flex, Image, shouldForwardProp } from "@chakra-ui/react";
import { isValidMotionProp, motion } from "framer-motion";
import { COMMON_WEB_PATH } from "../../constant";
import { useEffect, useState } from "react";
import {
  ALREADY_SHOW_LOSS_POINT_MODAL_STATE,
  RESET_LOSS_POINT_MODAL_STATE,
} from "../../redux/action/member/memberAction";
import { useTranslation } from "react-i18next";
import useWebsiteInfo from "../../hook/useWebsiteInfo";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

//輸分已達到，不可充值彈窗
//輸分已達到，不可充值彈窗
//輸分已達到，不可充值彈窗
const LossPointModal = () => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);
  const [showModal, setShowModal] = useState(false);

  const { isLogin } = useCheckLogin();
  const { images } = useWebsiteInfo();

  const dispatch = useDispatch();
  const isLossPointState = useSelector((state) => state.isLossPointState);
  const isMemberInfo = useSelector((state) => state.isMemberInfo);

  //玩家狀態，5為凍結輸分
  const { status } = isMemberInfo || {};

  const handleConfirm = () => {
    dispatch(ALREADY_SHOW_LOSS_POINT_MODAL_STATE());
    setShowModal(false);
  };

  useEffect(() => {
    if (isLogin) {
      //登入後才會判斷
      if (status === 5) {
        //當狀態為5(凍結輸分)時，且初始輸分MODAL為true時，彈出提示框
        if (isLossPointState) {
          setShowModal(true);
        }
      } else {
        //用來重置狀態
        //因為有可能後台會將機台的狀態改為其他狀態
        dispatch(RESET_LOSS_POINT_MODAL_STATE());
      }
    }
  }, [isLogin, status, isLossPointState]);

  return (
    showModal && (
      <Flex
        position="fixed"
        top="0"
        left="0"
        right="0"
        bottom="0"
        bg="rgba(0, 0, 0, 0.8)"
        zIndex="9998"
        backdropFilter="blur(2px)"
        justifyContent="center"
        alignItems="center"
      >
        <ChakraBox
          as={Flex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3, delay: 0.3 }}
          w="520px"
          h="300px"
          bgImage={`url('${COMMON_WEB_PATH}/911TW/hintBG2.webp')`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100% 100%"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="space-between"
          position={"relative"}
          p={6}
        >
          <Flex
            fontSize="24px"
            color="white"
            textAlign="center"
            mt={4}
            bgImage={`url('${COMMON_WEB_PATH}/FlyDragon/hintTitleBG.webp')`}
            bgPosition="center"
            bgRepeat="no-repeat"
            bgSize="100% 100%"
            sx={{ width: "-webkit-fill-available" }}
            justifyContent="center"
            alignItems="center"
          >
            <Image
              src={`${COMMON_WEB_PATH}/FlyDragon/hintWORD.webp`}
              height={{
                base: "50px",
                xl: "60px",
              }}
            />
          </Flex>
          <Box fontSize="32px" color="white" textAlign="center" mb={2}>
            {i18n_common("lossPointModalTitle")}
          </Box>
          <Box fontSize="24px" color="white" textAlign="center" mb={2}>
            {i18n_common("lossPointModalContent")}
          </Box>

          <Flex
            gap={4}
            mb={4}
            justifyContent="space-between"
            alignItems="center"
          >
            <Flex
              as="button"
              w="165px"
              h="62px"
              bgImage={`url('${images.yesBTN}')`}
              bgPosition="center"
              bgRepeat="no-repeat"
              bgSize="100% 100%"
              justifyContent="center"
              alignItems="center"
              onClick={handleConfirm}
            >
              {/* <Image
                src={`${COMMON_WEB_PATH}/FlyDragon/yesWORD.webp`}
                width="70px"
                height={{
                  base: "30px",
                  xl: "30px",
                }}
              /> */}
            </Flex>
          </Flex>
        </ChakraBox>
      </Flex>
    )
  );
};

export default LossPointModal;
